export type CmtsEnvironmentConfig = {
  readonly CMTS_API_BASE_URL: string;
  readonly CMTS_AUTH_MODE: string;
  readonly CMTS_OPENAPI_URL: string;
  readonly CMTS_DEFAULT_TENANT_CODE?: string | undefined;
  readonly CMTS_ENABLE_OFFLINE_MODE: boolean;
  readonly CMTS_API_TIMEOUT_MS: number;
  readonly CMTS_CLIENT_APP_VERSION: string;
};



function readEnv(name: string): string | undefined {
  const metaEnv = (import.meta.env ?? {}) as Record<string, string | boolean | undefined>;
  const value = metaEnv[name];
  return typeof value === "string" && value.trim() ? value.trim() : undefined;
}

function readBooleanEnv(name: string, fallback: boolean): boolean {
  const value = readEnv(name);
  if (value === undefined) return fallback;
  return value.toLowerCase() === "true";
}

function readTimeoutMs(): number {
  const raw = readEnv("VITE_CMTS_API_TIMEOUT_MS");
  if (!raw) return 30000;
  const parsed = Number.parseInt(raw, 10);
  return Number.isFinite(parsed) && parsed >= 5000 ? parsed : 30000;
}

function normalizeBaseUrl(value: string | undefined): string {
  const base = value?.replace(/\/+$/, "");
  if (!base) return "https://cmtsapi.atribsglobal.com/api/cmts";
  return base.replace(/(\/api\/cmts)+$/i, "/api/cmts");
}

export const cmtsEnv: CmtsEnvironmentConfig = {
  CMTS_API_BASE_URL: normalizeBaseUrl(readEnv("VITE_CMTS_API_BASE_URL")),
  CMTS_AUTH_MODE: readEnv("VITE_CMTS_AUTH_MODE") ?? "bearer",
  CMTS_OPENAPI_URL: readEnv("VITE_CMTS_OPENAPI_URL") ?? `${normalizeBaseUrl(readEnv("VITE_CMTS_API_BASE_URL"))}/swagger/v1/swagger.json`,
  CMTS_DEFAULT_TENANT_CODE: readEnv("VITE_CMTS_DEFAULT_TENANT_CODE") ?? readEnv("VITE_CMTS_TENANT_CODE"),
  CMTS_ENABLE_OFFLINE_MODE: readBooleanEnv("VITE_CMTS_ENABLE_OFFLINE_MODE", readBooleanEnv("VITE_CMTS_ENABLE_OFFLINE_DEMO", false)),
  CMTS_API_TIMEOUT_MS: readTimeoutMs(),
  CMTS_CLIENT_APP_VERSION: readEnv("VITE_CMTS_CLIENT_APP_VERSION") ?? "cmts-frontend-local",
};

